import { User, onAuthStateChanged } from 'firebase/auth';
import React, { useState } from 'react';

import { createNamedContext, useRequiredContext } from '@helpers/Context';
import { logError } from '@helpers/Loggers';
import { auth } from '@helpers/firebase/Initialize';

export type AuthenticationContextProps = {
  loading: boolean;
  loggedIn: boolean;
  error: boolean;
};

export const AuthenticationContext = createNamedContext<AuthenticationContextProps>({
  AuthenticationContext: undefined,
});

export function useAuthentication() {
  return useRequiredContext(AuthenticationContext);
}

export function AuthenticationProvider({ children }: React.PropsWithChildren) {
  const [loading, setLoading] = React.useState(true);
  const [loggedIn, setLoggedIn] = useState(false);
  const [error, setError] = useState(false);

  const onNext = (user: User | null) => {
    if (user) {
      setLoggedIn(true);
    } else {
      setLoggedIn(false);
    }
    setLoading(false);
  };

  const onError = (error: Error) => {
    logError(error);
    setLoading(false);
    setError(true);
  };

  React.useEffect(() => {
    return onAuthStateChanged(auth, onNext, onError);
  }, []);

  const value = { loading, loggedIn, error };

  return <AuthenticationContext.Provider value={value}>{children}</AuthenticationContext.Provider>;
}
